'use client';

import { useProjectPermissions } from './useProjectPermissions';

/**
 * 역할 기반 훅의 compatibility adapter.
 *
 * 판정 기준은 더 이상 역할 문자열이 아니라 permission이다. 기존 소비처가 쓰던 이름만 유지하고
 * 내부는 `useProjectPermissions`로 위임한다. 새 화면은 `useProjectPermissions`를 직접 쓰세요.
 *
 * 부수 효과로 이 훅이 더는 프로젝트·팀 **멤버 전체 목록**을 받아오지 않는다. 내 권한을 알려고
 * 다른 사람의 이메일·역할까지 내려받던 구조가 사라졌다.
 *
 * `currentRole`은 표시용 힌트일 뿐이다. built-in 대응이 없는 사용자 정의 역할만 가진 사용자는
 * null이 되므로, 이 값으로 권한을 판정하면 안 된다.
 */
export const useProjectRole = (overrides?: { projectId?: string; teamId?: string }) => {
  const { can, isLoading, error, roles } = useProjectPermissions({ projectId: overrides?.projectId });

  const builtInKey = roles.find((role) => role.builtInKey !== null)?.builtInKey ?? null;
  const currentRole =
    builtInKey === 'PROJECT_OWNER' ? 'OWNER' : builtInKey === 'PROJECT_ADMIN' ? 'ADMIN' : builtInKey ? 'MEMBER' : null;

  return {
    currentRole,
    canEditConventions: can('conventions.write'),
    isLoadingRole: isLoading,
    roleError: error,
  };
};
